import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function listPortalUsers(params: any) {
  const queryParams = new URLSearchParams();
  queryParams.set("pageNo", params?.pageNo || "1");
  queryParams.set("pageSize", params?.pageSize || "25");

  return executeRequest({
    path: `/portal-users/list?${queryParams.toString()}`,
    method: "get",
  });
}

async function getPortalUserInfo(id: string) {
  if (!id) throw new Error("No portal user id provided");

  return executeRequest({
    path: `/portal-users/info/${id}`,
    method: "get",
  });
}

async function createPortalUser(params: any) {
  return executeRequest({
    path: "/portal-users/create",
    payload: params,
    method: "post",
  });
}

async function updatePortalUser(id: string, params: any) {
  return executeRequest({
    path: `/portal-users/update/${id}`,
    payload: params,
    method: "patch",
  });
}

async function deletePortalUser(id: string) {
  return executeRequest({
    path: `/portal-users/delete/${id}`,
    method: "delete",
  });
}

async function resetPortalUserPassword(id: string) {
  return executeRequest({
    path: `/portal-users/reset-password/${id}`,
    method: "post",
  });
}

async function unlockPortalUser(id: string) {
  return executeRequest({
    path: `/portal-users/unlock/${id}`,
    method: "post",
  });
}

async function listPortalUserAuditLogs(userId: string, params: any) {
  const queryParams = new URLSearchParams();
  queryParams.set("pageNo", params?.pageNo || "1");
  queryParams.set("pageSize", params?.pageSize || "25");

  return executeRequest({
    path: `/portal-users/audit-logs/${userId}?${queryParams.toString()}`,
    method: "get",
  });
}

export {
  listPortalUsers,
  getPortalUserInfo,
  createPortalUser,
  updatePortalUser,
  deletePortalUser,
  resetPortalUserPassword,
  unlockPortalUser,
  listPortalUserAuditLogs,
};
